export default function DubaiMap () {
  const zoom = 15
  const mapType = 'roadmap'
  const lat = '25.222251726240813'
  const lng = '55.40821113149976'
  const width = '100%'
  const height = '100%'
  const style = {}

  return (
    <iframe
      width={width}
      height={height}
      style={{ border: 0, filter: 'grayscale(30%)', ...style }}
      frameBorder='0'
      referrerPolicy='no-referrer-when-downgrade'
      loading='lazy'
      allowFullScreen
      aria-hidden='false'
      tabIndex='0'
      src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyA5f6xxPvHUlkCFxkAct5wbG1ylJmSqGRU&zoom=${zoom}&maptype=${mapType}&q=${lat},${lng}`}
    />
  )
}
